import * as React from 'react';
import { Typography, Grid, Chip, Popover } from '@mui/material';

export default function StandardsDisplay(props) {
  const { standards } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openedPopoverId, setOpenedPopoverId] = React.useState(null);

  const handlePopoverOpen = (event, popoverId) => {
    setAnchorEl(event.currentTarget);
    setOpenedPopoverId(popoverId);
  };

  const handlePopoverClose = () => {
    setOpenedPopoverId(null);
    setAnchorEl(null);
  };

  React.useEffect(() => {
    document.addEventListener('scroll', handlePopoverClose, true);
    return () => {
      document.removeEventListener('scroll', handlePopoverClose, true);
    };
  }, []);

  return (
    <Grid
      container
      direction='row'
      justifyContent='flex-start'
      alignItems='flex-start'
      spacing={1}
    >
      {standards.map((standard) => (
        <Grid item key={standard.linktivity_sk}>
          <Chip
            label={standard.standard_subject + ' ' + standard.standard_notation}
            onClick={(e) => handlePopoverOpen(e, standard.linktivity_sk)}
          ></Chip>
          <Popover
            id={'popover-' + standard.linktivity_sk}
            open={openedPopoverId === standard.linktivity_sk}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            onClick={handlePopoverClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'left',
            }}
            PaperProps={{
              style: { maxWidth: '300px' },
            }}
            disableScrollLock={true}
          >
            <Typography variant='body2' sx={{ p: 1 }}>
              <b>
                {standard.standard_subject + ' ' + standard.standard_notation}
              </b>
              <br />
              {standard.standard_description}
            </Typography>
          </Popover>
        </Grid>
      ))}
    </Grid>
  );
}
